import { UNITS } from "./units";
import { ControlType, Section, Field } from "@cotecna/dynamic-view-engine";

const NEW_PRODUCT_FIELDS: Field[] = [
  {
    id: "name",
    type: ControlType.Input,
    label: "Item",
    order: 1,
    propertyName: "name",
    value: "",
    required: true,
    visible: true,
    valid: false,
  },
  {
    id: "quantity",
    type: ControlType.NumericInput,
    label: "Expected Quantity",
    order: 2,
    propertyName: "quantity",
    value: "",
    required: false,
    visible: true,
    valid: true,
  },
  {
    id: "unit",
    type: ControlType.Dropdown,
    label: "Unit",
    order: 3,
    propertyName: "unit",
    value: "UNT",
    readableValue: "UNT",
    required: false,
    visible: true,
    valid: true,
  },
  {
    id: "form",
    type: ControlType.Dropdown,
    label: "Form",
    order: 4,
    propertyName: "form",
    value: "",
    required: true,
    visible: true,
    valid: false,
  },
];

export const NEW_PRODUCT_FORM: Section[] = [
  {
    id: "1",
    name: "",
    isFixed: true,
    order: 1,
    fields: NEW_PRODUCT_FIELDS,
    actions: [],
  },
];

export const NEW_PRODUCT_CONTROLS: any[] = [
  {
    id: "name",
    maxLength: 50,
  },
  {
    id: "quantity",
  },
  {
    id: "unit",
    options: UNITS,
  },
  {
    id: "form",
    values: [],
  },
];
